import React, { useEffect, useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select';
import Modal from 'react-responsive-modal';
import useForm from 'react-hook-form';
import Loader from '../common/loader';
import api from '../../config/axios';
import utils from '../../utils/miscUtils';
import { date, time, diasDesdeFecha } from '../../utils/date';
import { useStateValue } from '../../store';
import { getBottlesPurchase, getTimeFormat, emojiRequested } from './utils';
import IconoBotellon from '../../assets/images/dashboard/icon-botellon.png';
import { Clock, DollarSign } from 'react-feather';
import { DELIVERY_CHANGE_REASONS } from './common/constants'

import ModalObservation from './components/modal-observation';

const { currency } = utils;

const ModalChangeDeliveryUser = (props) => {
    const {
        visibleModalDU,
        setVisibleModalDU,
        onSave,
        handleClose,
        userDelivery,
        setUserDelivery,
        users,
        purchase,
        userLogged
    } = props;
    const { handleSubmit, register } = useForm();

    const handleChangeDelivery = (form) => {

        const description = `${userLogged.role} (${userLogged.name}) reasignó pedido #${purchase.id} de ${purchase.user.name} a ${userDelivery.label
            }. Motivo: ${visibleModalDU.action.split('-')[0]}-${form.description || 'N/A'}`;

        const deliveryChangeReason = DELIVERY_CHANGE_REASONS.find(d => d.value === visibleModalDU.action)
        const descriptionPush = `Motivo: ${deliveryChangeReason.label}`;

        const data = {
            userId: userDelivery.value,
            action: visibleModalDU.action.split('-')[1],
            description,
            descriptionPush
        };
        onSave(data);
    };

    return (
        <Modal
            open={visibleModalDU.visible}
            onClose={handleClose}
            classNames={{ modal: 'customModal' }}
        >
            <div className="modal-header">
                <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                    Cambio de repartidor
                </h5>
            </div>
            <div className="modal-body">
                <div className="form-group">
                    <div className="col-xl-6 col-sm-7 p-0">
                        <label>Asignar pedido:</label>
                        <div>
                            <Select
                                name="userDeliveryId"
                                placeholder="Selecciona el repartidor"
                                onChange={(value) => setUserDelivery(value)}
                                value={userDelivery}
                                options={users.map((user) => {
                                    return {
                                        value: user.id,
                                        label: user.name,
                                    };
                                })}
                            />
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <p>Motivo del cambio</p>
                </div>
                <div className="form-group">
                    {DELIVERY_CHANGE_REASONS.map(({ id, value, label }) => (
                        <div key={id} className="col-xl-6 col-sm-7 p-0">
                            <input
                                type="radio"
                                id={id}
                                name="action"
                                value={value}
                                checked={visibleModalDU.action === value}
                                onClick={() => setVisibleModalDU({ ...visibleModalDU, action: value })}
                            />
                            &nbsp;&nbsp;
                            <label htmlFor={id}>{label}</label>
                        </div>
                    ))}
                </div>
                <div className="form-group">
                    <textarea
                        type="text"
                        className="form-control mb-2"
                        name="description"
                        rows="3"
                        ref={register({
                            required: false,
                        })}
                        placeholder="(Opcional) Escribe aquí una nota del cambio de pedido."
                    />
                </div>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmit(handleChangeDelivery)}
                >
                    aceptar
                </button>
            </div>
        </Modal>
    );
};

const ModalEditDeliveryDetails = (props) => {
    const { purchase, visible, onSave, handleClose } = props;

    const { handleSubmit, register } = useForm({
        defaultValues: {
            delivery_time: purchase.delivery_time,
            change_cash: purchase.changeCash,
            payment_confirmation_id: purchase.payment_confirmation_id,
            preNote: purchase.preNote,
        },
    });

    const handleUpdate = (data) => {
        onSave({
            delivery_time: data.delivery_time,
            change_cash: data.change_cash,
            payment_confirmation_id: data.payment_confirmation_id,
            preNote: data.preNote,
        });
    };

    return (
        <Modal open={visible} onClose={handleClose} classNames={{ modal: 'customModal' }}>
            <div className="modal-header">
                <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                    Detalles de entrega
                </h5>
            </div>
            <div className="modal-body">
                <div className="form">
                    {purchase.paymentMethod && purchase.paymentMethod.accounts ? (
                        <div className="form-group row">
                            <label className="col-xl-3 col-sm-4 mb-0">
                                5 dígitos (pago móvil):
                            </label>
                            <div className="col-xl-4 col-sm-7 col-10 offset-1 p-0">
                                <input
                                    className="form-control"
                                    placeholder="Ejm: 12345"
                                    name="payment_confirmation_id"
                                    type="text"
                                    inputMode="numeric"
                                    ref={register({
                                        required: false,
                                    })}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="form-group row">
                            <label className="col-xl-3 col-sm-4 mb-0">Billete a pagar:</label>
                            <div className="col-xl-4 col-sm-7 col-10 offset-1 p-0">
                                <input
                                    className="form-control"
                                    placeholder="Ejm: 20.000 o 50.000"
                                    name="change_cash"
                                    type="text"
                                    inputMode="numeric"
                                    ref={register({
                                        required: false,
                                    })}
                                />
                            </div>
                        </div>
                    )}
                    <hr />
                    <div className="form-group row">
                        <label className="col-xl-3 col-sm-4 mb-0">Hora de entrega:</label>
                        <div className="col-xl-4 col-sm-7 col-10 offset-1 p-0">
                            <input
                                className="form-control"
                                placeholder="Selecciona la hora"
                                name="delivery_time"
                                type="time"
                                ref={register({
                                    required: false,
                                })}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-sm-4 mb-0">Nota pre-entrega:</label>
                        <div className="col-xl-4 col-sm-7 col-10 offset-1 p-0">
                            <input
                                className="form-control"
                                placeholder="Ejm: Dejar con el vigilante"
                                name="preNote"
                                type="text"
                                ref={register({
                                    required: false,
                                })}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmit(handleUpdate)}
                >
                    modificar
                </button>
            </div>
        </Modal>
    );
};

const ModalQuantity = (props) => {
    const { purchase, visible, onSave, handleClose } = props;

    const { handleSubmit, register } = useForm({
        defaultValues: {
            quantity: purchase.quantity,
        },
    });

    const handleUpdate = (data) => {
        onSave({
            quantity: data.quantity,
        });
    };

    return (
        <Modal open={visible} onClose={handleClose} classNames={{ modal: 'customModal' }}>
            <div className="modal-header">
                <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                    Cantidad de recargas
                </h5>
            </div>
            <div className="modal-body">
                <div className="form">
                    <div className="form-group row">
                        <label className="col-xl-3 col-sm-4 mb-0">Cantidad:</label>
                        <div className="col-xl-4 col-sm-7 col-10 offset-1 p-0">
                            <input
                                className="form-control"
                                placeholder="Ejm: 20.000 o 50.000"
                                name="quantity"
                                type="text"
                                inputMode="numeric"
                                ref={register({
                                    required: false,
                                })}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmit(handleUpdate)}
                >
                    modificar
                </button>
            </div>
        </Modal>
    );
};

const ModalPayment = (props) => {
    const { purchase, visible, onSave, fetchPaymentMethods, handleClose } = props;
    const [paymentMethods, setPaymentMethods] = useState([]);

    useEffect(() => {
        fetchPaymentMethods().then((response) => setPaymentMethods(response));
    }, []);

    const { handleSubmit, register, setValue } = useForm({
        defaultValues: {
            paymentMethodId: purchase.paymentMethodId,
        },
    });

    const handleUpdate = (data) => {
        onSave({
            paymentMethodId: data.paymentMethodId.id,
        });
    };

    return (
        <Modal open={visible} onClose={handleClose} classNames={{ modal: 'customModal' }}>
            <div className="modal-header">
                <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                    Forma de pago
                </h5>
            </div>
            <div className="modal-body">
                <div className="form">
                    <div className="form-group row">
                        <label className="col-xl-3 col-sm-4 mb-0">Actual:</label>
                        <div className="col-xl-4 col-sm-7 col-10 offset-1 p-0">
                            <p className="mb-0 font-weight-bold">{purchase.paymentMethod.name}</p>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-sm-4 mb-0">Nueva forma de pago:</label>
                        <div className="col-xl-6 col-sm-6 col-10 offset-1 p-0">
                            <Select
                                name="paymentMethodId"
                                placeholder="Selecciona aquí"
                                onChange={(value) => setValue('paymentMethodId', value)}
                                options={paymentMethods.map((paymentMethod) => {
                                    return {
                                        ...paymentMethod,
                                        value: paymentMethod.id,
                                        label: paymentMethod.name,
                                    };
                                })}
                                isSearchable={false}
                                ref={() =>
                                    register(
                                        {
                                            name: 'paymentMethodId',
                                            type: 'custom',
                                        },
                                        {
                                            required: true,
                                        },
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmit(handleUpdate)}
                >
                    modificar
                </button>
            </div>
        </Modal>
    );
};

const ModalAddress = (props) => {
    const { purchase, visible, onSave, fetchAddressesByClient, handleClose } = props;
    const [addresses, setAddresses] = useState([]);

    useEffect(() => {
        fetchAddressesByClient(purchase.client.id).then((response) => setAddresses(response));
    }, []);

    const { handleSubmit, register, setValue } = useForm({
        defaultValues: {
            addressId: purchase.addressId,
        },
    });

    const handleUpdate = (data) => {
        onSave({
            addressId: data.addressId.id,
        });
    };

    return (
        <Modal open={visible} onClose={handleClose} classNames={{ modal: 'customModal' }}>
            <div className="modal-header">
                <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                    Modificar dirección
                </h5>
            </div>
            <div className="modal-body">
                <div className="form">
                    <div className="form-group row">
                        <p className="col-xl-5 col-sm-5 mb-2">
                            Dirección actual: {purchase.address.street1}
                        </p>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-sm-4 mb-0">Nueva dirección:</label>
                        <div className="col-xl-6 col-sm-6 col-10 offset-1 p-0">
                            <Select
                                name="addressId"
                                placeholder="Selecciona aquí"
                                onChange={(value) => setValue('addressId', value)}
                                options={addresses.map((address) => {
                                    return {
                                        ...address,
                                        value: address.id,
                                        label: address.street1,
                                    };
                                })}
                                isSearchable={false}
                                ref={() =>
                                    register(
                                        {
                                            name: 'addressId',
                                            type: 'custom',
                                        },
                                        {
                                            required: true,
                                        },
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmit(handleUpdate)}
                >
                    modificar
                </button>
            </div>
        </Modal>
    );
};

const ModalRequestedFrom = (props) => {
    const { purchase, visible, onSave, handleClose } = props;

    const { handleSubmit, register, setValue } = useForm({
        defaultValues: {
            requestedFrom: purchase.requestedFrom,
        },
    });

    const handleUpdate = (data) => {
        onSave({
            requestedFrom: data.requestedFrom.value,
        });
    };

    const optionsToChange = [{ value: 'app', label: 'App' }, { value: 'bot', label: 'Bot' }, { value: 'admin', label: 'Admin' }]

    return (
        <Modal open={visible} onClose={handleClose} classNames={{ modal: 'customModal' }}>
            <div className="modal-header">
                <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                    Modificar valor de pedido
                </h5>
            </div>
            <div className="modal-body">
                <div className="form">
                    <div className="form-group row">
                        <p className="col-xl-5 col-sm-5 mb-2">
                            Valor actual: {purchase.requestedFrom}
                        </p>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-sm-4 mb-0">Nuevo valor:</label>
                        <div className="col-xl-6 col-sm-6 col-10 offset-1 p-0">
                            <Select
                                name="requestedFrom"
                                placeholder="Selecciona aquí"
                                onChange={(value) => setValue('requestedFrom', value)}
                                options={optionsToChange}
                                isSearchable={false}
                                ref={() =>
                                    register(
                                        {
                                            name: 'requestedFrom',
                                            type: 'custom',
                                        },
                                        {
                                            required: true,
                                        },
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmit(handleUpdate)}
                >
                    modificar
                </button>
            </div>
        </Modal>
    );
};

const ModalNotificationOptions = (props) => {
    const { visible, onSave, handleClose } = props;
    const [selectedOption, setSelectedOption] = useState(null);

    const notificationOptions = [
        {
            id: 1,
            title: '🌧️ *Demora por lluvia*',
            body: 'La entrega tardará un poco más de lo esperado.\n\nAgradecemos tu paciencia.',
        },
        {
            id: 2,
            title: '⏳ *Una pequeña demora*',
            body: '¡Estamos trabajando en ello! La entrega se demora 15-20 minutos.\n\nGracias por la compresión.',
        },
        {
            id: 3,
            title: '🔧 *Pausa técnica*',
            body: 'Nuestro repartidor tuvo un problema mecánico, ya lo estamos solucionando.\n\nTu pedido llegará en 15-20 minutos.',
        },
    ];

    const handleSubmit = () => {
        if (selectedOption) {
            const option = notificationOptions.find((opt) => opt.id === selectedOption);
            onSave(option);
            setSelectedOption(null);
        }
    };

    return (
        <Modal open={visible} onClose={handleClose} classNames={{ modal: 'customModal' }}>
            <div className="modal-header">
                <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                    Selecciona el motivo de la demora
                </h5>
            </div>
            <div className="modal-body">
                <div className="form">
                    {notificationOptions.map((option) => (
                        <div key={option.id} className="form-group">
                            <div className="d-flex align-items-center">
                                <input
                                    type="radio"
                                    id={`option-${option.id}`}
                                    name="notificationOption"
                                    value={option.id}
                                    checked={selectedOption === option.id}
                                    onChange={() => setSelectedOption(option.id)}
                                />
                                &nbsp;&nbsp;
                                <label htmlFor={`option-${option.id}`}>
                                    <strong>{option.title}</strong>
                                    <br />
                                    <small>{option.body.substring(0, 70)}... </small>
                                </label>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmit}
                    disabled={!selectedOption}
                >
                    Enviar notificación
                </button>
            </div>
        </Modal>
    );
};

const ModalClientInfo = (props) => {
    const { visible, handleClose, client } = props;

    return (
        <Modal open={visible} onClose={handleClose} classNames={{ modal: 'customModal' }}>
            <div className="modal-header">
                <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                    Información adicional
                </h5>
            </div>
            <div className="modal-body">
                <div className="card">
                    <div className="card-body">
                        <div className="row mb-2">
                            <strong>📧 {client?.email}</strong>
                        </div>

                        <div className="row mb-2">
                            <strong>📱 {client.phone_number}</strong>
                        </div>
                        <hr />
                        <div className="row mb-2">
                            <p>
                                <strong>{client?.legalInformation?.businessName}</strong>
                            </p>
                        </div>

                        <div className="row mb-1">
                            <p>{client?.legalInformation?.rif}</p>
                        </div>

                        <div className="row mb-1">
                            <p>{client?.legalInformation?.phoneNumber}</p>
                        </div>
                        <div className="row mb-1">
                            <p>{client?.legalInformation?.address}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-primary" onClick={handleClose}>
                    Cerrar
                </button>
            </div>
        </Modal>
    );
};

const ModalNewClientInstructions = (props) => {
    const { visible, handleClose, clientName } = props;

    return (
        <Modal open={visible} onClose={handleClose} classNames={{ modal: 'customModal' }}>
            <div className="modal-header">
                <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                    🎉 ¡Cliente Nuevo!
                </h5>
            </div>
            <div className="modal-body">
                <div className="card mb-1">
                    <div className="card-body">
                        <h5 className="card-title">
                            📝 <strong>Preguntas</strong> para el nuevo cliente:
                        </h5>
                        <ul className="list-unstyled">
                            <li className="mb-2">
                                <strong>¿Cómo nos conoció?</strong>
                            </li>
                            <li className="mb-2">
                                <strong>¿Qué hacía antes para comprar el botellón?</strong>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="card mb-1">
                    <div className="card-body">
                        <h5 className="card-title">
                            💡 <strong>Tips</strong> para la entrega:
                        </h5>
                        <ul style={{ listStyleType: 'normal' }}>
                            <li>
                                · <strong>Saluda</strong> con una sonrisa y preséntate.
                            </li>
                            <li>· Ofrécele ayuda para colocar el botellón.</li>
                            <li>
                                · Explícale brevemente <strong>cómo funciona el servicio</strong>.
                            </li>
                            <li>
                                · Invítalo a <strong>calificar la entrega</strong> en la app.
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="text-center mt-4">
                    <p className="text-muted font-weight-bold" style={{ color: '#444' }}>
                        Recuerda: La primera impresión es la que cuenta. ¡Hagamos que se sienta
                        especial!
                    </p>
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-primary" onClick={handleClose}>
                    Entendido
                </button>
            </div>
        </Modal>
    );
};

function PurchaseDetail(props) {
    const [{ auth }] = useStateValue();
    const purchaseId = props.match.params.id;
    const [loaded, setLoaded] = useState(false);
    const [purchase, setPurchase] = useState([]);
    const [users, setUsers] = useState([]);
    const [userDelivery, setUserDelivery] = useState(null);
    const [loadingPurchase, setLoadingPurchase] = useState(false);
    const [visibleModalObservation, setVisibleModalObservation] = useState(false);
    const [visibleModalUpdateObservation, setVisibleModalUpdateObservation] = useState(false);
    const [visibleModalDeliveryDetails, setVisibleModalDeliveryDetails] = useState(false);
    const [visibleModalQuantity, setVisibleModalQuantity] = useState(false);
    const [visibleModalPayment, setVisibleModalPayment] = useState(false);
    const [visibleModalAddress, setVisibleModalAddress] = useState(false);
    const [visibleModalRequestedFrom, setVisibleModalRequestedFrom] = useState(false);
    const [visibleModalDU, setVisibleModalDU] = useState({
        visible: false,
        action: null,
        description: null,
    });
    const [visibleModalNotification, setVisibleModalNotification] = useState(false);
    const [visibleModalNewClient, setVisibleModalNewClient] = useState(false);
    const [visibleModalClientInfo, setVisibleModalClientInfo] = useState(false);

    useEffect(() => {
        fetchPurchase().then(async (purchase) => {
            const users = await fetchUsersByFranchise(purchase.franchise.id);
            setUsers(users);
            const purchasesClient = await fetchPurchasesByClient(purchase.client.id);
            const dataPurchase = {
                ...purchase,
                client: {
                    ...purchase.client,
                    purchases: purchasesClient,
                },
            };
            setPurchase(dataPurchase);
            setLoaded(true);

            // Mostrar modal de cliente nuevo si es su primer pedido
            const pedidoEntregado = purchase.transactions.find(
                (item) => item.name === 'Pedido Entregado',
            );
            if (purchasesClient.count === 1 && !pedidoEntregado) {
                setVisibleModalNewClient(true);
            }
        });
    }, []);

    useEffect(() => {
        if (loaded) {
            let lat = null;
            let lng = null;
            if (purchase.client) {
                lat = purchase.address.latitude;
                lng = purchase.address.longitude;
            } else {
                lat = purchase.latitude;
                lng = purchase.longitude;
            }

            const googleScript = document.getElementById('map');

            if (window.google) {
                let map = new window.google.maps.Map(googleScript, {
                    center: { lat, lng },
                    zoom: 16,
                    mapTypeControl: false,
                    streetViewControl: false,
                });
                new window.google.maps.Marker({
                    position: { lat, lng },
                    map,
                });
            }

            googleScript.addEventListener('load', () => {
                // Patiently waiting to do the thing
                console.log('ya cargó');
            });
        }
    }, [loaded]);

    const fetchPurchase = async () => {
        const { data } = await api.get(`/purchase/${purchaseId}/detalle-admin`);
        const purchase = data.data;

        return purchase;
    };

    const fetchPaymentMethods = async () => {
        const { data } = await api.get(`/franchise/${purchase.franchise.id}/payment_method`);
        const paymentMethods = data.data;

        return paymentMethods;
    };

    const fetchAddressesByClient = async (clientId) => {
        const { data } = await api.get(`/client/${clientId}/address`);
        const addresses = data.data.rows;

        return addresses;
    };

    const fetchPurchasesByClient = async (clientId) => {
        const { data } = await api.get(`/client/${clientId}/purchases-admin`);
        const purchases = data.data;

        return purchases;
    };

    const fetchUsersByFranchise = async (franchiseId) => {
        const { data } = await api.get(`/franchise/${franchiseId}/users`);
        let users = null;
        if (auth.user.role === 'ADMIN' || auth.user.role === 'FRANCHISE') {
            users = data.data;
        } else {
            users = data.data.filter((user) => user.role === 'DELIVERY');
        }

        return users;
    };

    const handleFetchPurchase = async () => {
        fetchPurchase().then(async (purchase) => {
            const purchasesClient = await fetchPurchasesByClient(purchase.client.id);
            const dataPurchase = {
                ...purchase,
                client: {
                    ...purchase.client,
                    purchases: purchasesClient,
                },
            };
            setPurchase(dataPurchase);
            setLoaded(true);
        });
    };

    const confirmPayment = async () => {
        setLoadingPurchase(true);
        try {
            await api.post(`/purchase/${purchase.id}/confirmar-pago`);
            await handleFetchPurchase();
            setLoadingPurchase(false);
            toast.success('Pago confirmado. Se ha enviado una notificación al cliente.');
        } catch (error) {
            setLoadingPurchase(false);
            toast.error('Ha ocurrido un error. Intente de nuevo');
        }
    };

    const rejectOrder = async () => {
        setLoadingPurchase(true);
        try {
            await api.post(`/purchase/${purchase.id}/rechazar-pedido`, {
                observation: 'Incluir motivo',
            });
            await handleFetchPurchase();
            setLoadingPurchase(false);
            toast.info('Pago rechazado. Se ha enviado una notificación al cliente.');
        } catch (error) {
            setLoadingPurchase(false);
            toast.error('Ha ocurrido un error. Intente de nuevo');
        }
    };

    const sendOrder = async () => {
        setLoadingPurchase(true);
        let diasDesdeUltimoPedido = 0;
        try {
            // esto es cuando el ADMIN|FRANCHISE lleva un pedido
            // que puede estar atrasado

            if (purchase.userId && purchase.userId !== auth.user.id) {
                const oldUser = users.filter((user) => user.id === purchase.userId)[0];
                const dataDelivery = {
                    title: `🚨 REASIGNADO`,
                    body: `${auth.user.name.split(' ')[0]} está llevando el pedido de ${purchase.client.name}. Tomar previsiones.`,
                };
                await api.post(`/user/${purchase.userId}/push-notification`, dataDelivery);
            }

            const purchaseData = { purchaseId: purchase.id };
            await api.post(`/purchase/enviar-pedido`, purchaseData);
            await handleFetchPurchase();
            setLoadingPurchase(false);

            if (purchase.client.purchases.count > 1) {
                diasDesdeUltimoPedido = diasDesdeFecha(purchase.client.purchases.rows[1].createdAt)
            }
            // comportamiento cuando
            // 1. el cliente es principiante
            // 2. el cliente tiene MUCHO RATO sin pedir
            if (
                (purchase.client.purchases.count <= 3 && purchase.requestedFrom === 'admin') ||
                (purchase.client.purchases.count > 1 && diasDesdeUltimoPedido >= 45 && purchase.requestedFrom === 'admin')
            ) {
                window.open(`https://wa.me/${phoneParsed}?text=Hola%20${purchase.client.name.split(' ')[0]}%2C%20soy%20*${auth.user.name.split(' ')[0]}*%20el%20encargado%20de%20entregar%20su%20pedido%20de%20Aguaman.%0A%0AEn%20estos%20momentos%20*voy%20en%20camino*%20hacia%20all%C3%A1.%0A%0ALe%20avisar%C3%A9%20cuando%20est%C3%A9%20afuera.`, '_blank')
            } else {
                toast.info('Pedido enviado. Se ha enviado una notificación al cliente.');
            }
        } catch (error) {
            toast.error('Ha ocurrido un error. Intente de nuevo');
            setLoadingPurchase(false);
        }
    };

    const alertDelivery = async () => {
        setLoadingPurchase(true);
        // se busca en los deliveries disponibles
        // el id del usuario que tiene asignado el pedido
        let infoUserDelivery = null;
        if (purchase.userId === auth.user.id) {
            infoUserDelivery = auth.user
        } else {
            infoUserDelivery = users.find((user) => user.id === purchase.userId);
        }

        try {
            if (purchase.requestedFrom === 'app') {
                await api.post(`/client/${purchase.client.id}/notification/aviso-entrega`, {
                    orderId: purchase.id,
                    expoTokenDelivery: infoUserDelivery.pushToken,
                });
            } else if (purchase.requestedFrom === 'bot') {
                const data = {
                    type: 'interactive',
                    title: '🚨*Llegó el repartidor*',
                    body: `${infoUserDelivery.name.split(' ')[0]
                        } está afuera para hacer la entrega de tu pedido.`,
                    data: {
                        view: 'DetailOrder',
                        id: purchase.id,
                    }
                };
                // Enviar una opción donde la persona pueda decir
                // Ya voy
                // Dame 5 minutos
                await api.post(`/client/${purchase.client.id}/notification-bot`, data);
            }
            setLoadingPurchase(false);
            toast.info('Se ha enviado la notificación al cliente.');
        } catch (error) {
            console.log(error)
            setLoadingPurchase(false);
            toast.error('Ha ocurrido un error. Intente de nuevo');
        }
    };

    const deliveredOrder = async (observation, transactionId, imageUrl, addressData) => {
        setLoadingPurchase(true);
        try {
            setVisibleModalObservation(false);
            await api.post(`/purchase/${purchase.id}/pedido-entregado`, {
                observation: observation && observation.trim() !== '' ? observation : null,
                clientId: purchase.client.id,
                imageUrl: imageUrl,
            });

            // actualizar la dirección del cliente
            // información adicional
            if (addressData) {
                await api.put(`/client/${purchase.client.id}/address/${purchase.address.id}`, {
                    ...purchase.address,
                    ...addressData,
                });
            }
            // notificacion de entrega al administrador
            if (observation && observation.trim() !== '') {
                await api.post(`/news`, {
                    description: observation,
                    orderId: purchase.id,
                });
            }

            await handleFetchPurchase();
            setLoadingPurchase(false);
            toast.success('Pedido entregado. Se ha enviado una notificación al cliente.');
        } catch (error) {
            setLoadingPurchase(false);
            toast.error('Ha ocurrido un error. Intente de nuevo');
        }
    };

    const cancelOrder = async () => {
        setLoadingPurchase(true);
        try {
            await api.post(`/purchase/${purchase.id}/cancelar-pedido`, {
                observation: 'N/A',
            });
            await api.post(`/news`, {
                description: 'Pedido cancelado por el administrador: ' + auth.user.name,
                orderId: purchase.id,
            });
            // mostrar modal para preguntar si se envia notificación o no
            setLoadingPurchase(false);
            toast.warning('Pedido Cancelado');
            props.history.replace('/');
        } catch (error) {
            setLoadingPurchase(false);
            toast.error('Ha ocurrido un error. Intente de nuevo');
        }
    };

    const deleteOrder = async () => {
        setLoadingPurchase(true);
        try {
            await api.delete(`/purchase/${purchase.id}`, {
                observation: 'N/A',
            });
            // mostrar modal para preguntar si se envia notificación o no
            setLoadingPurchase(false);
            toast.warning('Pedido Eliminado');
            props.history.replace('/');
        } catch (error) {
            setLoadingPurchase(false);
            toast.error('Ha ocurrido un error. Intente de nuevo');
        }
    };

    const sendToBotWhatsapp = async () => {
        setLoadingPurchase(true);
        try {
            await api.post(`/purchase/${purchase.id}/enviar-seguimiento-bot`);
            setLoadingPurchase(false);
            toast.warning('Mensaje enviado al BOT');
        } catch (error) {
            setLoadingPurchase(false);
            toast.error('Ha ocurrido un error. Intente de nuevo');
        }
    }

    const assignOrder = async (dataDeliveryUser) => {
        if (userDelivery) {
            setLoadingPurchase(true);
            try {
                // send push notification to OLD DELIVERY USER
                if (purchase.userId) {
                    const oldUser = users.filter((user) => user.id !== purchase.userId)[0];
                    const dataDelivery = {
                        title: `🚨 REASIGNADO`,
                        body: `Pedido de ${purchase.client.name}. ${dataDeliveryUser.descriptionPush}`,
                    };
                    await api.post(`/user/${purchase.userId}/push-notification`, dataDelivery);
                }

                // asignar pedido
                await api.post(`/purchase/${purchase.id}/user/${userDelivery.value}`);

                // guardar en histórico
                await handleDeliveryHistory(
                    auth.user.id,
                    dataDeliveryUser.action,
                    dataDeliveryUser.description,
                );
                await handleFetchPurchase();
                setVisibleModalDU({ visible: false });
                setLoadingPurchase(false);
                toast.success('Pedido asignado con éxito');
            } catch (error) {
                setLoadingPurchase(false);
                toast.error('Ha ocurrido un error. Intente de nuevo');
            }
        } else {
            toast.warning('Selecciona un usuario repartidor');
        }
    };

    const notifyExhangeOrder = async () => {
        const userToAssign = users.filter((user) => user.id !== auth.user.id)[0];
        setLoadingPurchase(true);
        try {
            await api.post(`/purchase/${purchase.id}/user/${userToAssign.id}`);

            // send push notification to DELIVERY USER
            const dataDelivery = {
                title: `🚨${userToAssign.name.slice(0, 2)} ${auth.user.name} NO puede entregar este pedido`,
                body: `El sistema te asignó el pedido de ${purchase.client.name}`,
            };
            await api.post(`/user/${purchase.userId}/push-notification`, dataDelivery);

            await handleDeliveryHistory(
                auth.user.id,
                'INTENTIONAL_CHANGE',
                `${auth.user.name} no pudo entregar el pedido. Asignado para ${userToAssign.name}(${userToAssign.id})`,
            );
            await handleFetchPurchase();
            setLoadingPurchase(false);
            toast.success('El pedido ha sido asignado a otro delivery.');
        } catch (error) {
            setLoadingPurchase(false);
            toast.error('Ha ocurrido un error. Intente de nuevo');
        }
    };

    const updateTransaction = async (observation, transactionId, imageObservation) => {
        setLoadingPurchase(true);
        try {
            setVisibleModalUpdateObservation(false);
            await api.put(`/purchase/${purchase.id}/transaction/${transactionId}`, {
                observation: observation && observation !== '' ? observation : null,
                imageObservation:
                    imageObservation && imageObservation !== '' ? imageObservation : null,
            });

            if (observation && observation.trim() !== '') {
                await api.post(`/news`, {
                    description: observation,
                    orderId: purchase.id,
                });
            }
            await handleFetchPurchase();
            setLoadingPurchase(false);
            toast.success('Transacción actualizada');
        } catch (error) {
            setLoadingPurchase(false);
            toast.error('Ha ocurrido un error. Intente de nuevo');
        }
    };

    const handleDeliveryHistory = async (userId, action, description) => {
        const data = {
            userId,
            action,
            description,
        };

        try {
            await api.post(`/delivery_user_history`, data);
        } catch (e) {
            console.log(e);
        }
    };

    const updatePurchase = async (data) => {
        setLoadingPurchase(true);
        try {
            setVisibleModalDeliveryDetails(false);
            await api.put(`/purchase/${purchase.id}`, {
                delivery_time:
                    data.delivery_time && data.delivery_time !== '' ? data.delivery_time : null,
                changeCash: data.change_cash && data.change_cash !== '' ? data.change_cash : null,
                payment_confirmation_id:
                    data.payment_confirmation_id && data.payment_confirmation_id !== ''
                        ? data.payment_confirmation_id
                        : null,
                preNote: data.preNote && data.preNote !== '' ? data.preNote : null,
            });
            if (
                data.delivery_time !== '' &&
                data.delivery_time !== purchase.delivery_time &&
                !pedidoHaSidoEntregado
            ) {
                // send push notification to DELIVERY USER
                const dataHora = {
                    title: `🚨 HORA DE ENTREGA: ${data.delivery_time ? getTimeFormat(data.delivery_time) : 'EXPRESS'
                        }`,
                    body: `Se actualizó la hora de: ${purchase.client.name}.`,
                };
                await api.post(`/user/${purchase.userId}/push-notification`, dataHora);
            }
            if (
                purchase.paymentMethod.currency !== 'VES' &&
                !!data.change_cash &&
                data.change_cash !== purchase.changeCash &&
                !pedidoHaSidoEntregado
            ) {
                // send push notification to DELIVERY USER
                const dataVueltos = {
                    title: `🚨 VUELTOS PARA: ${data.change_cash} ${purchase.paymentMethod.name.split(' ')[0]
                        }`,
                    body: `Llevar vueltos al pedido de: ${purchase.client.name}.`,
                };
                await api.post(`/user/${purchase.userId}/push-notification`, dataVueltos);
            }

            if (
                data.preNote !== '' &&
                data.preNote !== purchase.preNote &&
                !pedidoHaSidoEntregado
            ) {
                // send push notification to DELIVERY USER
                const dataPreNote = {
                    title: `🚨 NOTA PEDIDO ${purchase.client.name}`,
                    body: `${data.preNote}`,
                };
                await api.post(`/user/${purchase.userId}/push-notification`, dataPreNote);
            }

            await handleFetchPurchase();
            setLoadingPurchase(false);
            toast.success('Pedido modificado. Se envió la notificación al repartidor.');
        } catch (error) {
            setLoadingPurchase(false);
            toast.error('Ha ocurrido un error. Intente de nuevo');
        }
    };

    const updateQuantityPurchase = async (data) => {
        setLoadingPurchase(true);
        try {
            setVisibleModalQuantity(false);
            await api.put(`/purchase/${purchase.id}/quantity`, {
                quantity: data.quantity,
            });
            if (data.quantity !== purchase.quantity && !pedidoHaSidoEntregado) {
                // send push notification to DELIVERY USER
                const dataNotification = {
                    title: '🚨 NUEVA CANTIDAD DEL PEDIDO',
                    body: `Pedido de: ${purchase.client.name}. Cantidad: ${data.quantity}`,
                };
                await api.post(`/user/${purchase.userId}/push-notification`, dataNotification);
            }
            await handleFetchPurchase();
            setLoadingPurchase(false);
            toast.success('Cantidad modificada');
        } catch (error) {
            setLoadingPurchase(false);
            toast.error('Ha ocurrido un error. Intente de nuevo');
        }
    };

    const updatePaymentPurchase = async (data) => {
        setLoadingPurchase(true);
        try {
            setVisibleModalPayment(false);

            await api.put(`/purchase/${purchase.id}/payment`, {
                paymentMethodId: data.paymentMethodId,
            });
            if (data.paymentMethodId !== purchase.paymentMethod.id && !pedidoHaSidoEntregado) {
                // send push notification to DELIVERY USER
                const dataNotification = {
                    title: '🚨 NUEVA FORMA DE PAGO',
                    body: `Pedido de: ${purchase.client.name}. Revisa el detalle de pedido`,
                };
                await api.post(`/user/${purchase.userId}/push-notification`, dataNotification);
            }
            await handleFetchPurchase();
            setLoadingPurchase(false);
            toast.success('Método de pago modificado');
        } catch (error) {
            setLoadingPurchase(false);
            toast.error('Ha ocurrido un error. Intente de nuevo');
        }
    };

    const updateAddressPurchase = async (data) => {
        setLoadingPurchase(true);
        try {
            setVisibleModalAddress(false);

            await api.put(`/purchase/${purchase.id}/address`, {
                addressId: data.addressId,
            });
            if (data.addressId !== purchase.address.id && !pedidoHaSidoEntregado) {
                // send push notification to DELIVERY USER
                const dataNotification = {
                    title: '🚨 NUEVA DIRECCIÓN DE ENTREGA',
                    body: `Pedido de: ${purchase.client.name}. Revisa el detalle de pedido`,
                };
                await api.post(`/user/${purchase.userId}/push-notification`, dataNotification);
            }

            await handleFetchPurchase();
            setLoadingPurchase(false);
            toast.success('Dirección modificada');
        } catch (error) {
            setLoadingPurchase(false);
            toast.error('Ha ocurrido un error. Intente de nuevo');
        }
    };

    const updateRequestedFrom = async (data) => {
        setLoadingPurchase(true);
        try {
            setVisibleModalRequestedFrom(false);

            await api.put(`/purchase/${purchase.id}/requested-from`, {
                requestedFrom: data.requestedFrom,
            });

            await handleFetchPurchase();
            setLoadingPurchase(false);
            toast.success('Valor modificado');
        } catch (error) {
            setLoadingPurchase(false);
            toast.error('Ha ocurrido un error. Intente de nuevo');
        }
    };

    const renderBadge = (status) => {
        switch (status) {
            case 'Pedido Creado':
                return (
                    <span style={{ fontSize: 16, height: 25 }} className="badge badge-warning">
                        Creado
                    </span>
                );
            case 'Pago Confirmado':
                return (
                    <span style={{ fontSize: 16, height: 25 }} className="badge badge-info">
                        Pago Confirmado
                    </span>
                );
            case 'Pedido Enviado':
                return (
                    <span style={{ fontSize: 16, height: 25 }} className="badge badge-info">
                        Enviado
                    </span>
                );
            case 'Pedido Recibido':
                return (
                    <span style={{ fontSize: 16, height: 25 }} className="badge badge-success">
                        Recibido
                    </span>
                );
            case 'Pedido Rechazado':
                return (
                    <span style={{ fontSize: 16, height: 25 }} className="badge badge-danger">
                        Rechazado
                    </span>
                );
            case 'Pedido Entregado':
                return (
                    <span style={{ fontSize: 16, height: 25 }} className="badge badge-success">
                        Entregado
                    </span>
                );
            case 'Pedido Cancelado':
                return (
                    <span style={{ fontSize: 16, height: 25 }} className="badge badge-danger">
                        Cancelado
                    </span>
                );
            default:
                return null;
        }
    };

    const badgeSourceOrder = (label) => (
        <span style={{ fontSize: 16, height: 25 }} className="badge badge-info">
            {label}
        </span>
    );
    const renderMarkers = (map, maps, address) => {
        new maps.Marker({
            position: {
                lat: address.latitude,
                lng: address.longitude,
            },
            map,
            title: 'Prueba',
        });
    };

    const renderBitacora = () => {
        return purchase.transactions
            .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
            .map((item, index) => {
                return (
                    <div key={`bitacora-${index}`}>
                        <div className="d-flex justify-content-between mb-3">
                            <div>
                                <p>
                                    <strong>{item.name.split(' ')[1]}</strong>
                                </p>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <p>
                                    {date(item.createdAt).split('-')[0]}/
                                    {date(item.createdAt).split('-')[1]} {time(item.createdAt)}
                                </p>
                            </div>
                        </div>
                    </div>
                );
            });
    };

    const sendPushNotification = async (notificationData) => {
        setLoadingPurchase(true);
        try {
            const data = {
                type: 'text',
                title: notificationData.title,
                body: notificationData.body,
                data: {
                    view: 'DetailOrder',
                    id: purchase.id,
                },
            };

            if (purchase.requestedFrom === 'app') {
                await api.post(`/client/${purchase.client.id}/notification`, data);
            } else if (purchase.requestedFrom === 'bot') {
                await api.post(`/client/${purchase.client.id}/notification-bot`, data);
            }
            setLoadingPurchase(false);
            toast.success('Se envió la notificación al cliente');
        } catch (error) {
            setLoadingPurchase(false);
            toast.error('Ha ocurrido un error. Intente de nuevo');
        }
    };

    const onCloseModalObservation = () => {
        setVisibleModalObservation(false);
    };

    const onCloseModalUpdateObservation = () => {
        setVisibleModalUpdateObservation(false);
    };

    const onCloseModalDeliveryDetails = () => {
        setVisibleModalDeliveryDetails(false);
    };

    const onCloseModalChangeDeliveryUser = () => {
        setVisibleModalDU({ ...visibleModalDU, visible: false });
    };

    const openModalChangeDelivery = () => {
        setVisibleModalDU({ ...visibleModalDU, visible: true });
    };

    // Ordenar las transacciones de cada pedido
    // para obtener la última transacción
    // en su defecto es la transacción "Pedido Entregado"
    const getLastTransaction = (purchase) => {
        const lastTransaction = purchase.transactions.reduce((a, b) =>
            a.createdAt > b.createdAt ? a : b,
        );

        return lastTransaction;
    };

    /**
     * Ordenar los pedidos para encontrar el pedido
     * más cercano (viejo) al pedido actual
     * @param {String} purchase Pedido actual
     * @param {Array} array Arreglo de todos los pedidos del cliente
     * @returns {Object} Retorna el pedido más cercano
     */
    const getClosestPurchase = (purchase, array) => {
        // Ordenar el arreglo de transacciones del más viejo al más nuevo
        const transactionsOfCurrentAddress = array.filter(
            (item) => item.address.id === purchase.address.id,
        );
        const sortedTransactions = transactionsOfCurrentAddress.sort(
            (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
        );

        var closestPurchase =
            sortedTransactions
                .reverse()
                .find(({ createdAt }) => new Date(createdAt) < new Date(purchase.createdAt)) ||
            sortedTransactions[0];

        return closestPurchase;
    };

    /**
     * Retorna la observación del pedido anterior al actual
     * ej: si tiene 3 pedidos [1,4,8] y el pedido actual es 8
     * se va a retornar la observación del pedido 4
     * @param {Object} purchase Pedido actual
     * @returns {String} Observación del pedido anterior al actual
     */
    const getObservationClosestPurchase = (purchase) => {
        if (purchase.client.purchases.rows.length === 1) return null;
        const closestPurchase = getClosestPurchase(purchase, purchase.client.purchases.rows);

        const transaction = getLastTransaction(closestPurchase);
        if (!transaction.observation && !transaction.imageObservation) return null;

        const date = new Date(transaction.createdAt);

        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        const stringDate = `${day}/${month}/${year}`;

        return (
            <div>
                <p>
                    <strong style={{ color: 'red' }}>{transaction.observation}</strong>
                </p>
                {transaction.imageObservation && (
                    <div>
                        <a href={transaction.imageObservation} target="_blank">
                            <img width={200} src={transaction.imageObservation} alt="observation" />
                        </a>
                    </div>
                )}
                <p style={{ color: 'black', fontWeight: 'bold' }}>
                    {stringDate} - {closestPurchase.user.name.split(' ')[0]}
                </p>
            </div>
        );
    };

    /**
     * Retorna la observación del pedido actual
     * @param {Object} purchase Pedido actual
     * @returns {String} Observación del pedido anterior al actual
     */
    const getObservationThisPurchase = (purchase) => {
        const transaction = getLastTransaction(purchase);

        if (!transaction.observation && !transaction.imageObservation) return null;

        const date = new Date(transaction.createdAt);

        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        const stringDate = `${day}/${month}/${year}`;
        return (
            <div>
                <p>
                    <strong style={{ color: 'red' }}>{transaction.observation}</strong>
                </p>
                {transaction.imageObservation && (
                    <div>
                        <a href={transaction.imageObservation} target="_blank">
                            <img width={200} src={transaction.imageObservation} alt="observation" />
                        </a>
                    </div>
                )}
                <p style={{ color: 'black', fontWeight: 'bold' }}>
                    {stringDate} - {purchase.user.name.split(' ')[0]}
                </p>
            </div>
        );
    };

    const copyOrderDetailToClipboard = (purchase) => {
        const response = `✅ Pedido Registrado\n\n📍 ${purchase.address.street1}, ${purchase.address.street2}\n💧 *${purchase.products[0].purchaseProducts.quantity
            } recarga${purchase.products[0].purchaseProducts.quantity > 1 ? 's' : ''
            } de botellón*\n🪙 ${purchase.paymentMethod.name.replace('VES', 'Bs')}\n\nTotal a pagar: *${purchase.products[0].purchaseProducts.quantity *
            Number(purchase.products[0].purchaseProducts.unitPrice)
            } ${purchase.paymentMethod.currency.replace('VES', 'Bs')}*\n\nLa entrega se hará en el transcurso de *30${purchase.address.longway ? '-45' : ''
            } minutos*.`;
        navigator.clipboard.writeText(response);
        toast.success('Respuesta copiada al portapapeles');
    };

    const copyTotalAmountToClipboard = (totalAmount, paymentMethodId) => {
        const response = utils.copyTotalAmountToClipboard(totalAmount, paymentMethodId)
        navigator.clipboard.writeText(response);
        toast.success('Respuesta copiada al portapapeles');
    };


    if (!loaded)
        return (
            <div style={{ display: 'flex', height: '50vh' }}>
                <Loader />
            </div>
        );

    let total = 0;

    if (purchase.products.length > 0) {
        total = purchase.products.reduce(
            (a, b) => a + b.purchaseProducts.quantity * b.purchaseProducts.unitPrice,
            0,
        );
    } else if (purchase.paymentMethod && purchase.products.length === 0) {
        total =
            Number(purchase.quantity) * Number(purchase.unity_amount_refill) +
            Number(purchase.quantity_new_bottles) * Number(purchase.amount_new_bottle) +
            Number(purchase.quantity_starterkit) * Number(purchase.amount_starterkit) +
            Number(purchase.quantity_dispenser) * Number(purchase.amount_dispenser);
    }

    if (purchase.firstOrderFree) {
        total = total - Number(purchase.unity_amount_refill);
    }

    const pedidoHaSidoEnviado =
        purchase.transactions.find(
            (item) =>
                item.name === 'Pedido Enviado' ||
                item.name === 'Pedido Rechazado' ||
                item.name === 'Pedido Recibido',
        ) !== undefined;

    const pedidoHaSidoEntregado = purchase.transactions.find(
        (item) => item.name === 'Pedido Entregado',
    );

    const pedidoHaSidoCancelado = purchase.transactions.find(
        (item) => item.name === 'Pedido Cancelado',
    );

    const pedidoHaSidoRechazado = purchase.transactions.find(
        (item) => item.name === 'Pedido Rechazado',
    );

    const lastTransaction = purchase.transactions.reduce((a, b) =>
        a.createdAt > b.createdAt ? a : b,
    );

    const getFirstTransaction = (purchase) =>
        purchase.transactions.reduce((a, b) => (b.createdAt > a.createdAt ? a : b));

    const isAdmin = auth.user.role === 'ADMIN' || auth.user.role === 'FRANCHISE';
    const isSuperAdmin = auth.user.role === 'ADMIN';
    const productRecargas = purchase.products.find((item) => item.name === 'Recarga');

    // calcular el monto del cupón para restarlo al monto total
    if (purchase.coupon) {
        total = total - Number(purchase.couponAmount);
    }

    // Observación dada por el delivery en el pedido anterior
    const observationClosestPurchase = getObservationClosestPurchase(purchase);
    const observationThisPurchase = getObservationThisPurchase(purchase);

    // bandera que el usuario activo (usando la interfaz)
    // es el mismo que tiene asignado el pedido
    const isUserDelivery = purchase.userId === auth.user.id;

    // bandera para mostrar a primera hora
    const hourPurchase = new Date(getFirstTransaction(purchase).createdAt).getHours();

    const firstMomentNextDate = () => {
        const purchaseWeekday = new Date(purchase.createdAt).getDay();
        const deliveryWeekday = purchase.delivery.weekday;

        if (deliveryWeekday) {
            if (purchaseWeekday === deliveryWeekday && hourPurchase < 8) {
                return true;
            } else if (purchaseWeekday != deliveryWeekday) {
                return true;
            }
        } else {
            if (hourPurchase > 8 && hourPurchase < 18) {
                // no se hace nada
                return false;
            } else {
                // horario fuera del habitual
                return true;
            }
        }
        return false;
    };

    const regexPhoneNumberPreNote =
        /(?:\+?58|0)?[\s-]?(?:4(?:12|14|424|16|426|22)|2(?:12|\d{2}))[\s-]?\d{3}[\s-]?\d{4}/gim;

    const handleCallNote = (note) => {
        if (
            note.match(regexPhoneNumberPreNote) &&
            note.match(regexPhoneNumberPreNote).length > 0
        ) {
            window.open(`tel:${note.match(regexPhoneNumberPreNote)[0]}`, '_blank');
        }
    };

    const phoneParsed = purchase.client.phone_number;
    const whatsappUrl = () =>
        `https://wa.me/${phoneParsed}?text=Hola, soy ${purchase.user.name.split(' ')[0]
        } de Aguaman.%0a%0aEstoy%20en%20la%20puerta%20para%20entregarte%20el%20pedido.`;

    const whatsappUrlObservation = () =>
        `https://wa.me/${phoneParsed}?text=Hola, Sr(a) ${purchase.client.name.split(' ')[0]
        }. Dejaré la siguiente nota relacionado su pedido en nuestro sistema: %0A%0A${lastTransaction.observation
        }. %0A%0ASi tiene alguna observación con esta nota por favor me la hace saber. Gracias`;

    return (
        <Fragment>
            <div className="container-fluid container-order-detail pt-1">
                <div className="row">
                    <div className="col-lg-6 col-sm-12">
                        <div className="card">
                            <div className="card-body" style={{ paddingBottom: 0 }}>
                                <div className="d-flex justify-content-between align-items-center">
                                    <p
                                        style={{ margin: 0, fontSize: 14 }}
                                        className="d-flex align-items-center"
                                    >
                                        #{purchase.id}{' '}
                                        {isAdmin && (
                                            <button
                                                className="btn btn-xs"
                                                onClick={() => copyOrderDetailToClipboard(purchase)}
                                            >
                                                <i className="fa fa-copy"></i>
                                            </button>
                                        )}
                                    </p>
                                    <div>
                                        {isSuperAdmin && (
                                            <button
                                                className="btn btn-xs"
                                                onClick={() => setVisibleModalRequestedFrom(true)}
                                            >
                                                <i className="fa fa-pencil"></i>
                                            </button>
                                        )}
                                        {emojiRequested[purchase.requestedFrom]}&nbsp;
                                        {renderBadge(lastTransaction.name)}&nbsp;
                                        {purchase.address.longway && (
                                            <span
                                                style={{ fontSize: 16, height: 25 }}
                                                className="badge badge-info"
                                            >
                                                Larga
                                            </span>
                                        )}
                                    </div>
                                </div>
                                {!pedidoHaSidoCancelado && purchase.user && (
                                    <div className="d-flex justify-content-between align-items-center pt-2">
                                        <div className="d-flex justify-content-start align-items-center">
                                            <img
                                                src={purchase.user.profile_img}
                                                height={40}
                                                width={40}
                                                style={{ borderRadius: 40 }}
                                            />
                                            &nbsp;&nbsp;
                                            <p style={{ color: '#777', fontSize: 14 }}>
                                                {purchase.user.name.split(' ')[0]}{' '}
                                                {purchase.user.name.split(' ')[1].substring(0, 1)}.
                                            </p>
                                            &nbsp;
                                            {isAdmin && (
                                                <button
                                                    className="btn btn-xs"
                                                    onClick={openModalChangeDelivery}
                                                >
                                                    <i className="fa fa-pencil"></i>
                                                </button>
                                            )}
                                        </div>
                                        <div>
                                            <h4 style={{ fontWeight: 700, textTransform: 'none' }}>
                                                {purchase.delivery_time ? (
                                                    <span style={{ color: 'red' }}>
                                                        {getTimeFormat(purchase.delivery_time)}
                                                    </span>
                                                ) : firstMomentNextDate() ? (
                                                    '8:00am'
                                                ) : (
                                                    `${time(
                                                        getFirstTransaction(purchase).createdAt,
                                                    )} - Express`
                                                )}
                                            </h4>
                                        </div>
                                    </div>
                                )}
                                <hr />
                                <div className="order-box">
                                    <ul className="sub-total">
                                        {purchase.products.length > 0
                                            ? purchase.products.map((product, index) => (
                                                <li
                                                    className="d-flex justify-content-between"
                                                    key={`product-purchase-${index}`}
                                                >
                                                    <div className="description-item-checkout">
                                                        <div>
                                                            <h4
                                                                style={{
                                                                    fontWeight: 700,
                                                                    fontSize: 18,
                                                                    margin: 0,
                                                                }}
                                                            >
                                                                {
                                                                    product.purchaseProducts
                                                                        .quantity
                                                                }
                                                                &nbsp;
                                                                {product.name}
                                                                &nbsp;
                                                                {isAdmin &&
                                                                    product.name ===
                                                                    'Recarga' && (
                                                                        <button
                                                                            className="btn btn-xs"
                                                                            onClick={() =>
                                                                                setVisibleModalQuantity(
                                                                                    true,
                                                                                )
                                                                            }
                                                                        >
                                                                            <i className="fa fa-pencil"></i>
                                                                        </button>
                                                                    )}
                                                            </h4>
                                                        </div>
                                                    </div>
                                                    <div className="total-item-checkout">
                                                        {purchase.paymentMethod &&
                                                            !purchase.subscription ? (
                                                            <p style={{ fontWeight: 500 }}>
                                                                {purchase.paymentMethod.currency}{' '}
                                                                {currency(
                                                                    product.purchaseProducts
                                                                        .quantity *
                                                                    Number(
                                                                        product
                                                                            .purchaseProducts
                                                                            .unitPrice,
                                                                    ),
                                                                )}
                                                            </p>
                                                        ) : (
                                                            'N/A'
                                                        )}
                                                    </div>
                                                </li>
                                            ))
                                            : null}
                                        {purchase.products.length === 0 &&
                                            renderOldProducts(purchase)}
                                        {purchase.firstOrderFree && (
                                            <li className="d-flex justify-content-between">
                                                <div className="description-item-checkout">
                                                    <p style={{ color: 'green' }}>
                                                        <strong>Recarga gratis</strong>
                                                    </p>
                                                </div>
                                                <div className="total-item-checkout">
                                                    <strong
                                                        className="count"
                                                        style={{ color: 'green' }}
                                                    >
                                                        - {purchase.paymentMethod.currency}{' '}
                                                        {currency(purchase.unity_amount_refill)}
                                                    </strong>
                                                </div>
                                            </li>
                                        )}
                                        {purchase.coupon && (
                                            <li className="d-flex justify-content-between">
                                                <div className="description-item-checkout">
                                                    <p style={{ color: 'green' }}>
                                                        Cupón {purchase.coupon.code}
                                                        {isAdmin ? ` (${purchase.coupon.id})` : ''}
                                                    </p>
                                                </div>
                                                <div className="total-item-checkout">
                                                    <strong
                                                        className="count"
                                                        style={{ color: 'green' }}
                                                    >
                                                        - {purchase.paymentMethod.currency}{' '}
                                                        {currency(purchase.couponAmount)}
                                                    </strong>
                                                </div>
                                            </li>
                                        )}
                                        {purchase.paymentMethod && !purchase.subscription ? (
                                            <li style={{ paddingTop: 16 }}>
                                                <h5 style={{ color: '#777' }}></h5>
                                                <div style={{ textAlign: 'right' }}>
                                                    <h4>
                                                        <strong className="count">
                                                            {isAdmin && (
                                                                <button
                                                                    className="btn btn-xs"
                                                                    onClick={() =>
                                                                        setVisibleModalPayment(true)
                                                                    }
                                                                >
                                                                    <i className="fa fa-pencil"></i>
                                                                </button>
                                                            )}
                                                            &nbsp;
                                                            {purchase.paymentMethod.currency}{' '}
                                                            {currency(total)}
                                                            {isAdmin &&
                                                                purchase.paymentMethod.accounts && (
                                                                    <>
                                                                        &nbsp;
                                                                        <button
                                                                            className="btn btn-xs"
                                                                            onClick={() =>
                                                                                copyTotalAmountToClipboard(
                                                                                    currency(total),
                                                                                    purchase.paymentMethod,
                                                                                )
                                                                            }
                                                                        >
                                                                            <i className="fa fa-copy"></i>
                                                                        </button>
                                                                    </>
                                                                )}
                                                        </strong>
                                                    </h4>
                                                    {!purchase.paymentMethod.accounts && purchase.changeCash && (
                                                        <p style={{ fontSize: 15, marginTop: 4 }}>
                                                            {
                                                                purchase.paymentMethod.name.split(
                                                                    '(',
                                                                )[0]
                                                            }
                                                            (
                                                            <strong style={{ color: '#313131' }}>
                                                                {currency(
                                                                    purchase.changeCash,
                                                                ).trim()}
                                                            </strong>
                                                            )
                                                        </p>
                                                    )}
                                                    {purchase.paymentMethod.accounts && (
                                                        <p style={{ fontSize: 15, marginTop: 4 }}>
                                                            {
                                                                purchase.paymentMethod.name.split(
                                                                    '(',
                                                                )[0]
                                                            }
                                                            (
                                                            <strong style={{ color: '#666' }}>
                                                                {purchase.payment_confirmation_id}
                                                            </strong>
                                                            )
                                                        </p>
                                                    )}
                                                </div>
                                            </li>
                                        ) : null}
                                        {purchase.subscription ? (
                                            <li
                                                style={{
                                                    paddingTop: 16,
                                                    paddingBottom: 8,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                {pedidoHaSidoEntregado ? (
                                                    <span
                                                        style={{
                                                            fontSize: 16,
                                                            height: 25,
                                                        }}
                                                        className="badge badge-success"
                                                    >
                                                        Le quedan:{' '}
                                                        {purchase.subscription.availability}{' '}
                                                        recargas a favor
                                                    </span>
                                                ) : (
                                                    <span
                                                        style={{
                                                            fontSize: 16,
                                                            height: 25,
                                                            color: 'black',
                                                        }}
                                                        className="badge badge-warning"
                                                    >
                                                        Tiene:{' '}
                                                        {Number(
                                                            purchase.subscription.availability,
                                                        ) +
                                                            Number(purchase.quantity) -
                                                            (purchase.couponId ? 1 : 0)}{' '}
                                                        recargas a favor
                                                    </span>
                                                )}
                                            </li>
                                        ) : null}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-sm-12 mb-1">
                            {loadingPurchase && (
                                <div
                                    className="d-flex justify-content-center"
                                    style={{ height: 150 }}
                                >
                                    <Loader />
                                </div>
                            )}
                            {!loadingPurchase &&
                                !pedidoHaSidoEnviado &&
                                !pedidoHaSidoCancelado &&
                                (isUserDelivery || auth.user.role === 'ADMIN' || auth.user.role === 'FRANCHISE') ? (
                                <div className="d-flex justify-content-center">
                                    <button className="btn btn-lg btn-primary" onClick={sendOrder}>
                                        enviar pedido
                                    </button>
                                </div>
                            ) : null}
                            {!loadingPurchase &&
                                pedidoHaSidoEnviado &&
                                !pedidoHaSidoEntregado &&
                                !pedidoHaSidoRechazado ? (
                                <div className="d-flex justify-content-center">
                                    {((purchase.requestedFrom === 'app' && !!purchase.client.expoToken) ||
                                        purchase.requestedFrom === 'bot') && (
                                            <button
                                                className="btn btn-lg btn-warning"
                                                onClick={alertDelivery}
                                            >
                                                <i className="fa fa-bell"></i>
                                            </button>
                                        )}
                                    &nbsp;&nbsp;
                                    <a
                                        className="btn btn-lg btn-info"
                                        href={`tel:+${purchase.client.phone_number}`}
                                    >
                                        <i className="fa fa-phone"></i>
                                    </a>
                                    &nbsp;&nbsp;
                                    <a
                                        className="btn btn-lg btn-success btn-whatsapp"
                                        href={whatsappUrl()}
                                        target="_blank"
                                    >
                                        <i className="fa fa-whatsapp"></i>
                                    </a>
                                </div>
                            ) : null}
                            {!loadingPurchase &&
                                pedidoHaSidoEnviado &&
                                !pedidoHaSidoEntregado &&
                                !pedidoHaSidoRechazado ? (
                                <div className="d-flex justify-content-center mt-3 mb-2">
                                    <button
                                        className="btn btn-lg btn-success"
                                        onClick={() => setVisibleModalObservation(true)}
                                    >
                                        entregado
                                    </button>
                                </div>
                            ) : null}
                            {auth.user.role === 'ADMIN' &&
                                !purchase.user &&
                                !pedidoHaSidoEnviado ? (
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row align-items-end">
                                            <div className="col-lg-6 col-12">
                                                <label>Asignar pedido:</label>
                                                <div>
                                                    <Select
                                                        name="userDeliveryId"
                                                        placeholder="Selecciona el repartidor"
                                                        onChange={(value) => setUserDelivery(value)}
                                                        value={userDelivery}
                                                        options={users.map((user) => {
                                                            return {
                                                                value: user.id,
                                                                label: user.name,
                                                            };
                                                        })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 text-center mt-3">
                                                <button
                                                    className="btn btn-lg btn-success"
                                                    onClick={assignOrder}
                                                >
                                                    asignar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <div className="card">
                            <div className="card-body">
                                <div>
                                    {purchase.preNote && (
                                        <div className="d-flex justify-content-center align-items-center flex-column">
                                            <p
                                                style={{
                                                    fontSize: 18,
                                                    color: 'black',
                                                    backgroundColor: '#ffbc58',
                                                    borderRadius: 5,
                                                    padding: '0 .3em',
                                                    cursor: 'pointer',
                                                }}
                                                onClick={() => handleCallNote(purchase.preNote)}
                                            >
                                                <strong>{purchase.preNote}</strong>
                                            </p>
                                        </div>
                                    )}
                                    {productRecargas && (
                                        <div className="d-flex justify-content-between">
                                            <div className="d-flex align-items-center">
                                                <img
                                                    src={IconoBotellon}
                                                    alt="Botellones"
                                                    height="30"
                                                />
                                                &nbsp;&nbsp;
                                                <p>
                                                    <strong>
                                                        {getBottlesPurchase(
                                                            productRecargas.purchaseProducts
                                                                .quantity,
                                                            purchase.address.newBottles,
                                                        )}
                                                    </strong>
                                                </p>
                                            </div>
                                            <div className="d-flex align-items-center pr-3">
                                                {purchase.address.publicSite && (
                                                    <span className="ml-2">
                                                        <i className="fa fa-eye"></i>
                                                    </span>
                                                )}
                                                {purchase.address.coolingDispenser && (
                                                    <span className="ml-2">
                                                        <i
                                                            className="fa fa-snowflake-o"
                                                            style={{ color: 'blue' }}
                                                        ></i>
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    {purchase.address.photoBottle && (
                                        <a href={purchase.address.photoBottle} target="_blank">
                                            <img
                                                src={purchase.address.photoBottle}
                                                width={100}
                                                alt="envase cliente"
                                            />
                                        </a>
                                    )}
                                    {observationThisPurchase ||
                                        (observationClosestPurchase && !pedidoHaSidoEntregado) ? (
                                        <hr />
                                    ) : null}
                                    {observationThisPurchase && (
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'flex-end',
                                                marginTop: 8,
                                            }}
                                        >
                                            {observationThisPurchase}
                                        </div>
                                    )}
                                    {observationClosestPurchase && !pedidoHaSidoEntregado && (
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'flex-end',
                                                marginTop: 8,
                                            }}
                                        >
                                            {observationClosestPurchase}
                                        </div>
                                    )}
                                    {purchase.address.observation && (
                                        <p
                                            className="text-danger"
                                            style={{
                                                cursor: purchase.address.observation.match(
                                                    regexPhoneNumberPreNote,
                                                )
                                                    ? 'pointer'
                                                    : 'default',
                                            }}
                                            onClick={() =>
                                                handleCallNote(purchase.address.observation)
                                            }
                                        >
                                            <strong>{purchase.address.observation}</strong>
                                        </p>
                                    )}
                                    {pedidoHaSidoEntregado && (
                                        <div
                                            style={{
                                                marginTop: 16,
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <button
                                                className="btn btn-xs"
                                                onClick={() =>
                                                    setVisibleModalUpdateObservation(true)
                                                }
                                            >
                                                Editar nota
                                            </button>
                                            &nbsp;
                                            {observationThisPurchase && (
                                                <a
                                                    className="btn btn-xs btn-info"
                                                    href={whatsappUrlObservation(
                                                        observationThisPurchase,
                                                    )}
                                                >
                                                    Enviar nota al cliente
                                                </a>
                                            )}
                                        </div>
                                    )}
                                    {isAdmin && (
                                        <div style={{ position: 'absolute', top: 10, right: 10 }}>
                                            <button
                                                className="btn btn-xs"
                                                onClick={() => setVisibleModalDeliveryDetails(true)}
                                            >
                                                <i className="fa fa-pencil"></i>
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        {isAdmin &&
                            purchase.paymentMethod &&
                            purchase.paymentMethod.accounts &&
                            lastTransaction.name === 'Pedido Creado' &&
                            lastTransaction.name !== 'Pedido Rechazado' ? (
                            <div className="card">
                                <div className="card-body">
                                    <div className="mt-4 d-flex justify-content-between">
                                        <button
                                            className="btn btn-success"
                                            onClick={confirmPayment}
                                        >
                                            Confirmar
                                        </button>
                                        <button className="btn btn-danger" onClick={rejectOrder}>
                                            Rechazar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <div className="clearfix"></div>

                        {purchase.client ? (
                            <InfoClient
                                data={purchase}
                                renderMarkers={renderMarkers}
                                auth={auth}
                                renderBitacora={renderBitacora}
                                purchase={purchase}
                                pedidoHaSidoCancelado={pedidoHaSidoCancelado}
                                pedidoHaSidoEnviado={pedidoHaSidoEnviado}
                                userDelivery={userDelivery}
                                setUserDelivery={setUserDelivery}
                                users={users}
                                assignOrder={assignOrder}
                                openModalChange={openModalChangeDelivery}
                                setVisibleModalAddress={setVisibleModalAddress}
                                setVisibleModalClientInfo={setVisibleModalClientInfo}
                            />
                        ) : (
                            <InfoQuickClient data={purchase} renderMarkers={renderMarkers} />
                        )}
                    </div>
                    <div className="col-lg-6 col-sm-12"></div>
                    <div className="col-lg-6 col-sm-12">
                        <LastPurchases purchases={purchase.client.purchases.rows} />
                    </div>
                </div>
                <div className="row">
                    {isAdmin &&
                        !loadingPurchase &&
                        !pedidoHaSidoEntregado &&
                        //(purchase.requestedFrom === 'app' || purchase.requestedFrom === 'bot') &&
                        !pedidoHaSidoCancelado ? (
                        <div className="col-lg-12 col-sm-12 mb-4 d-flex justify-content-center">
                            <button
                                className="btn btn-sm btn-warning"
                                onClick={() => setVisibleModalNotification(true)}
                            >
                                notificar pedido demorado
                            </button>
                        </div>
                    ) : null}
                </div>
                <div className="row">
                    {!loadingPurchase &&
                        isUserDelivery &&
                        users.length > 1 &&
                        !pedidoHaSidoEnviado &&
                        !pedidoHaSidoEntregado &&
                        !pedidoHaSidoCancelado ? (
                        <div className="col-lg-12 col-sm-12 mb-4 d-flex justify-content-center">
                            <button className="btn btn-sm btn-danger" onClick={notifyExhangeOrder}>
                                no puedo entregar este pedido
                            </button>
                        </div>
                    ) : null}
                </div>
                <div className="row">

                    {isSuperAdmin && !loadingPurchase && !pedidoHaSidoEntregado ? (
                        <div className="col-lg-12 col-sm-12 mb-4 d-flex justify-content-center">
                            <button className="btn btn-sm btn-danger" onClick={deleteOrder}>
                                eliminar pedido
                            </button>
                        </div>
                    ) : null}
                    {isAdmin && !loadingPurchase && !pedidoHaSidoEntregado ? (
                        <div className="col-lg-12 col-sm-12 mb-4 d-flex justify-content-center">
                            <button className="btn btn-sm btn-danger" onClick={cancelOrder}>
                                cancelar pedido
                            </button>
                        </div>
                    ) : null}
                    {isSuperAdmin && !loadingPurchase && !pedidoHaSidoEnviado ? (
                        <div className="col-lg-12 col-sm-12 mb-4 d-flex justify-content-center">
                            <button className="btn btn-sm btn-success" onClick={sendToBotWhatsapp}>
                                Enviar al bot
                            </button>
                        </div>
                    ) : null}
                </div>
                <ModalObservation
                    purchase={purchase}
                    visible={visibleModalObservation}
                    onSave={deliveredOrder}
                    handleClose={onCloseModalObservation}
                    observationClosestPurchase={observationClosestPurchase}
                />
                {pedidoHaSidoEntregado && (
                    <ModalObservation
                        purchase={purchase}
                        visible={visibleModalUpdateObservation}
                        onSave={updateTransaction}
                        handleClose={onCloseModalUpdateObservation}
                        observationClosestPurchase={observationThisPurchase}
                        transactionId={pedidoHaSidoEntregado.id}
                    />
                )}
                <ModalEditDeliveryDetails
                    purchase={purchase}
                    visible={visibleModalDeliveryDetails}
                    onSave={updatePurchase}
                    handleClose={onCloseModalDeliveryDetails}
                    observationClosestPurchase={observationClosestPurchase}
                />
                <ModalChangeDeliveryUser
                    purchase={purchase}
                    users={users}
                    setUserDelivery={setUserDelivery}
                    userDelivery={userDelivery}
                    visibleModalDU={visibleModalDU}
                    setVisibleModalDU={setVisibleModalDU}
                    onSave={assignOrder}
                    handleClose={onCloseModalChangeDeliveryUser}
                    observationClosestPurchase={observationClosestPurchase}
                    userLogged={auth.user}
                />
                {visibleModalQuantity && (
                    <ModalQuantity
                        purchase={purchase}
                        visible={visibleModalQuantity}
                        onSave={updateQuantityPurchase}
                        handleClose={() => setVisibleModalQuantity(false)}
                    />
                )}
                {visibleModalPayment && (
                    <ModalPayment
                        purchase={purchase}
                        visible={visibleModalPayment}
                        onSave={updatePaymentPurchase}
                        fetchPaymentMethods={fetchPaymentMethods}
                        handleClose={() => setVisibleModalPayment(false)}
                    />
                )}
                {visibleModalAddress && (
                    <ModalAddress
                        purchase={purchase}
                        visible={visibleModalAddress}
                        onSave={updateAddressPurchase}
                        fetchAddressesByClient={fetchAddressesByClient}
                        handleClose={() => setVisibleModalAddress(false)}
                    />
                )}
                {visibleModalRequestedFrom && (
                    <ModalRequestedFrom
                        purchase={purchase}
                        visible={visibleModalRequestedFrom}
                        onSave={updateRequestedFrom}
                        handleClose={() => setVisibleModalRequestedFrom(false)}
                    />
                )}
                <ModalNotificationOptions
                    visible={visibleModalNotification}
                    onSave={sendPushNotification}
                    handleClose={() => setVisibleModalNotification(false)}
                />
                <ModalNewClientInstructions
                    visible={visibleModalNewClient}
                    handleClose={() => setVisibleModalNewClient(false)}
                    clientName={purchase.client?.name}
                />
                <ModalClientInfo
                    visible={visibleModalClientInfo}
                    handleClose={() => setVisibleModalClientInfo(false)}
                    client={purchase.client}
                />
            </div>
        </Fragment>
    );
}

const InfoClient = (props) => {
    const {
        data,
        auth,
        renderBitacora,
        purchase,
        pedidoHaSidoCancelado,
        pedidoHaSidoEnviado,
        userDelivery,
        setUserDelivery,
        users,
        assignOrder,
        openModalChange,
        setVisibleModalAddress,
        setVisibleModalClientInfo,
    } = props;
    const destination = `${data.address.latitude},${data.address.longitude}`;
    const isAdmin = auth.user.role === 'ADMIN' || auth.user.role === 'FRANCHISE';

    const getStatusClient = (count) => {
        if (count === 1) {
            return (
                <span style={{ fontSize: 16, height: 25 }} className="badge badge-success">
                    Nuevo
                </span>
            );
        } else if (count > 1 && count < 5) {
            return (
                <span style={{ fontSize: 16, height: 25 }} className="badge badge-info">
                    Principiante
                </span>
            );
        } else if ((count) => 5) {
            return (
                <span style={{ fontSize: 16, height: 25 }} className="badge badge-success">
                    Super Cliente
                </span>
            );
        }
    };

    return (
        <div>
            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center">
                            <h4 style={{ margin: 0, marginRight: 10, fontWeight: 'bold' }}>
                                {auth.user.role !== 'DELIVERY' ? (
                                    <Link
                                        to={`${process.env.PUBLIC_URL}/clientes/${data.client.id}`}
                                    >
                                        <strong>{data.client.name}</strong>
                                    </Link>
                                ) : (
                                    data.client.name
                                )}
                            </h4>
                            <button
                                className="btn btn-xs btn-outline-info"
                                onClick={() => setVisibleModalClientInfo(true)}
                                title="Ver información de contacto"
                            >
                                <i className="fa fa-info-circle"></i>
                            </button>
                        </div>
                        <div>{getStatusClient(data.client.purchases.count)}</div>
                    </div>
                    <p>
                        {data.address.gpsVerified && (
                            <i className="fa fa-check-circle text-primary"></i>
                        )}{' '}
                        {data.address.street1}, {data.address.street2}
                        &nbsp;
                        {isAdmin && (
                            <button
                                className="btn btn-xs"
                                onClick={() => setVisibleModalAddress(true)}
                            >
                                <i className="fa fa-pencil"></i>
                            </button>
                        )}
                    </p>
                    <p style={{ fontSize: '1.1em' }} className="mt-2">
                        <a href={`tel:+${data.client.phone_number}`}>Llamar</a>
                    </p>
                    <br />
                    <div id="map" style={{ width: '100%', height: 300 }}></div>
                    <div className="d-flex justify-content-center mt-1">
                        <a
                            href={`https://www.google.com/maps/search/?api=1&query=${destination}`}
                            className="btn btn-sm btn-outline-secondary mt-2"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Abrir en Google Maps
                        </a>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="card-body">
                    <div className="clearfix"></div>
                    <h4>Bitácora</h4>
                    <hr />
                    {renderBitacora()}
                </div>
            </div>
        </div>
    );
};

const LastPurchases = (props) => {
    const { purchases } = props;
    return (
        <div className="card">
            <div className="card-body">
                <div className="clearfix"></div>
                <h4>Últimos 3 pedidos</h4>
                <hr />
                {purchases.slice(0, 3).map((purchase, index) => {
                    return (
                        <div key={`lastPurchase-${index}`}>
                            <div className="d-flex justify-content-between align-items-start mb-3">
                                <div style={{ width: '50%' }}>
                                    <p style={{ fontSize: '1.1em' }}>
                                        <a
                                            href={`${process.env.PUBLIC_URL}/recargas/detalle/${purchase.id}`}
                                        >
                                            {utils.renderTextPedido(purchase)} - {purchase.id}
                                        </a>
                                    </p>
                                    <p style={{ fontSize: 14 }}>
                                        {purchase.address.street1.slice(0, 42)}
                                        {purchase.address.street1.length > 42 ? '...' : ''}
                                    </p>
                                </div>
                                <div style={{ textAlign: 'right' }}>
                                    <p>{date(purchase.createdAt)}</p>
                                    <p
                                        style={{
                                            fontSize: 14,
                                            fontStyle: 'italic',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {purchase.user?.name.split(' ')[0]}
                                    </p>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const InfoQuickClient = (props) => {
    const { data, renderMarkers } = props;
    const destination = `${data.latitude},${data.longitude}`;
    return (
        <div>
            <p>
                <strong>{data.nameQuick}</strong>
            </p>
            <p>{data.addressQuick}</p>
            <p>{data.phoneQuick}</p>
            <p style={{ textAlign: 'right' }}>Cliente sin registrarse</p>
            <br />
            <div className="d-flex justify-content-center">
                <a
                    href={`https://www.google.com/maps/search/?api=1&query=${destination}`}
                    className="btn btn-sm"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Abrir en Google Maps
                </a>
            </div>
            <div id="map" style={{ width: '100%', height: 300 }}></div>
        </div>
    );
};

const renderOldProducts = (purchase) => {
    return (
        <>
            {purchase.quantity > 0 ? (
                <li className="d-flex justify-content-between">
                    <div className="description-item-checkout">
                        <div>
                            <p>
                                <strong style={{ fontSize: 24 }}>{purchase.quantity}</strong>
                                Recarga{purchase.quantity > 1 && 's'}
                            </p>
                        </div>
                    </div>
                    <div className="total-item-checkout">
                        {purchase.paymentMethod ? (
                            <strong>
                                {purchase.paymentMethod.currency}{' '}
                                {currency(purchase.quantity * Number(purchase.unity_amount_refill))}
                            </strong>
                        ) : (
                            'N/A'
                        )}
                    </div>
                </li>
            ) : null}
            {purchase.quantity_new_bottles > 0 ? (
                <li className="d-flex justify-content-between">
                    <div className="description-item-checkout">
                        <div>
                            <p>
                                <strong style={{ fontSize: 24 }}>
                                    {purchase.quantity_new_bottles}
                                </strong>{' '}
                                Botellon
                                {purchase.quantity_new_bottles > 1 && 'es'} nuevo
                                {purchase.quantity_new_bottles > 1 && 's'}{' '}
                            </p>
                        </div>
                    </div>
                    <div className="total-item-checkout">
                        <strong>
                            {purchase.paymentMethod.currency}{' '}
                            {currency(purchase.quantity_new_bottles * purchase.amount_new_bottle)}
                        </strong>
                    </div>
                </li>
            ) : null}
            {purchase.quantity_starterkit > 0 ? (
                <li className="d-flex justify-content-between">
                    <div className="description-item-checkout">
                        <div>
                            <p>
                                <strong style={{ fontSize: 24 }}>
                                    {purchase.quantity_starterkit}
                                </strong>{' '}
                                Kit de Inicio (Botellón nuevo, dispensador y recarga)
                            </p>
                        </div>
                    </div>
                    <div className="total-item-checkout">
                        <strong>
                            {purchase.paymentMethod.currency}{' '}
                            {currency(purchase.quantity_starterkit * purchase.amount_starterkit)}
                        </strong>
                    </div>
                </li>
            ) : null}
            {purchase.quantity_dispenser > 0 ? (
                <li className="d-flex justify-content-between">
                    <div className="description-item-checkout">
                        <p>
                            <strong style={{ fontSize: 24 }}>{purchase.quantity_dispenser}</strong>{' '}
                            Dispensador
                            {purchase.quantity_dispenser > 1 && 'es'}{' '}
                        </p>
                    </div>
                    <div className="total-item-checkout">
                        <strong>
                            {purchase.paymentMethod.currency}{' '}
                            {currency(purchase.quantity_dispenser * purchase.amount_dispenser)}
                        </strong>
                    </div>
                </li>
            ) : null}
        </>
    );
};

export default PurchaseDetail;
